import { isArray } from '@ember/array';
import { isEmpty } from '@ember/utils';
import { SerializedLegacyFilter, SerializedLegacySegmentNegatableFilter } from 'cio/types/conditions/legacy-filter';

export default function getPeopleFilters(conditions: SerializedLegacyFilter[] | null) {
  if (!isArray(conditions) || isEmpty(conditions)) {
    return null;
  }

  let mappedConditions = conditions.map(function (condition) {
    if (condition.type === 'segments') {
      return {
        type: 'segments_negatable',
        negate: false,

        // legacy path:
        segments: (condition as unknown as SerializedLegacySegmentNegatableFilter).segments,
      } as SerializedLegacySegmentNegatableFilter;
    }

    return condition;
  });

  if (isEmpty(mappedConditions)) {
    return null;
  }

  return mappedConditions;
}
